import { CircularProgress, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";

import { Config } from "../../config/config";
import { getGlobalVar, Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface LeagueRewardsState {
    numberOfPlayers: number;
    excludePlayers: string;
    league: string;
    tournamentId: string;
    generating: boolean;
}

interface LeagueRewardsProps {
    activeUser: any;
    classes: any;
    activeEnv: any;
}

class FillTournamentsWrapped extends React.Component<LeagueRewardsProps, LeagueRewardsState> {

    constructor(props) {
        super(props);

        this.state = {
            league: "",
            excludePlayers: "",
            numberOfPlayers: 8,
            tournamentId: "",
            generating: false,
        };

        document.title = Helpers.documentTitle("Generate tournament");
    }
    generateUsers = async () => {
        try {
            this.setState({ generating: true });

            // Put data to S3
            const response = await axios.post(`${Config.getInstance.apiUrl}/api/tournaments/generate`, {
                league: this.state.league,
                excludePlayers: this.state.excludePlayers,
                numberOfPlayers: +this.state.numberOfPlayers,
                tournamentId: this.state.tournamentId,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

            PopupMessage.success(`${response.data.rooms.length} ${response.data.rooms.length === 1 ? "room" : "rooms"} added`);

            this.setState({ generating: false });
        } catch (error) {
            PopupMessage.error("Couldn't generate tournament");
        }
    }

    clearTournaments = async () => {
        try {
            // Put data to S3
            const response = await axios.delete(`${Config.getInstance.apiUrl}/api/tournaments/clear`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

            PopupMessage.success(`${response.data.tournamentCacheCleared} ${response.data.tournamentCacheCleared === 1 ? "room" : "rooms"} deleted`);
        } catch (error) {
            PopupMessage.error("Couldn't clear tournament list");
        }
    }

    handleChange = (name) => (event) => {
        let value = event.target.value;

        if (name === "numberOfPlayers") {
            if (value <= 0) { value = 1; }
            if (value > 50) { value = 50; }
        }

        this.setState({ [name]: value } as any);
    }

    render() {
        const { classes } = this.props;

        return <div className="contentPadding">
            <Paper className="root" elevation={0}>
                <div style={{ float: "left", padding: "15px 22px 15px 22px", width: "100%" }}>
                    <div className={classes.title}>
                        <Typography variant="h6" id="tableTitle">
                            Generate tournament
                        </Typography>
                    </div>
                </div>

                <div style={{ float: "left", width: "100%", padding: "15px 22px 15px 22px" }}>

                    <Grid container spacing={3}>
                        <Grid item xs={2}>
                            <InputLabel id="tournamentLabel">Tournament</InputLabel>
                            <Select
                                labelId="tournamentLabel"
                                value={this.state.tournamentId}
                                onChange={this.handleChange("tournamentId")}
                                style={{ width: "100%" }}
                            >
                                <MenuItem value="4064581k70gvm8j">Solo eliminations</MenuItem>
                                <MenuItem value="ef0ex1k70gvr6h">Duo eliminations</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel id="leagueLabel">League</InputLabel>
                            <Select
                                labelId="leagueLabel"
                                value={this.state.league}
                                onChange={this.handleChange("league")}
                                style={{ width: "100%" }}
                            >
                                {Helpers.uniqueArrayByKey(getGlobalVar("LEAGUES"), "league").map(item => (
                                    <MenuItem value={item.league} key={item.league}>{item.league}</MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label="Amount of users"
                                value={this.state.numberOfPlayers}
                                onChange={this.handleChange("numberOfPlayers")}
                                type="number"
                                className={classes.textField}
                                style={{ width: "100%" }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Exclude users"
                                placeholder="For example, 5e73e33b3286df0011357ace, 5e73e33b3286df0011357ace"
                                helperText="User id separated with comma"
                                value={this.state.excludePlayers}
                                onChange={this.handleChange("excludePlayers")}
                                className={classes.textField}
                                style={{ width: "40%" }}
                                maxRows={4}
                                rows={4}
                                multiline
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <div className={classes.wrapper}>
                                <Button disableElevation
                                    color="primary"
                                    size="medium"
                                    variant="contained"
                                    onClick={this.generateUsers}
                                    disabled={this.state.generating}
                                >
                                    Generate tournament

                                    {this.state.generating && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </Button>
                            </div>

                            <div className={classes.wrapper}>
                                <Button disableElevation
                                    color="secondary"
                                    size="medium"
                                    variant="contained"
                                    onClick={this.clearTournaments}
                                    disabled={this.state.generating}
                                    style={{ marginLeft: 10 }}
                                >
                                    Clear tournaments
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        </div>;
    }
}

const styles: any = theme => ({
    loadingButton: {
        width: "100%",
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        margin: 8,
        position: "relative",
        marginTop: 10,
        display: "inline-block",
    },
    title: {
        flex: "0 0 auto",
        float: "left",
    },
});

export const FillTournaments = withStyles(styles)(FillTournamentsWrapped);
